import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_GET_REQUEST,
  PROJECT_INFORMATION_GET_SUCCESS,
  PROJECT_INFORMATION_GET_FAILURE,
  PROJECT_INFORMATION_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_GET_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_GET_SUCCESS:
      return state
        .set('project', fromJS(action.payload.project))
        .set('projectSubmit', fromJS(action.payload.projectSubmit))
        .set('users', fromJS(action.payload.users))
        .set('changeableProjectStatus', fromJS(action.payload.changeableProjectStatus))
        .set('lastProjectSubmitRequest', fromJS(action.payload.lastProjectSubmitRequest))
        .set('crType', fromJS(action.payload.crType))
        .set('ppsLatestSubmittedDate', fromJS(action.payload.ppsLatestSubmittedDate))
        .set('canEditAllocation', fromJS(action.payload.canEditAllocation))
        .set('isFetching', false)
    case PROJECT_INFORMATION_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case PROJECT_INFORMATION_GET_RESET:
      return state
        .delete('project')
        .delete('users')
        .delete('changeableProjectStatus')
        .delete('lastProjectSubmitRequest')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-get-reducer.js